/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The EligibilitiesEligibility model module.
 * @module model/EligibilitiesEligibility
 * @version v0.3
 */
export default class EligibilitiesEligibility {
  /**
   * Constructs a new <code>EligibilitiesEligibility</code>.
   * @alias module:model/EligibilitiesEligibility
   * @class
   * @param insurancePolicyId {String} 
   */
  constructor(insurancePolicyId) {
    this.insurancePolicyId = insurancePolicyId;
  }

  /**
   * Constructs a <code>EligibilitiesEligibility</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EligibilitiesEligibility} obj Optional instance to populate.
   * @return {module:model/EligibilitiesEligibility} The populated <code>EligibilitiesEligibility</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EligibilitiesEligibility();
      if (data.hasOwnProperty('insurance_policy_id'))
        obj.insurancePolicyId = ApiClient.convertToType(data['insurance_policy_id'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} insurancePolicyId
 */
EligibilitiesEligibility.prototype.insurancePolicyId = undefined;

